// src/components/battle/BattleNameInput.jsx
export default function BattleNameInput({ value, onChange }) {
  return (
    <div className="mb-4 text-sm">
      <label className="block mb-2 font-medium text-slate-700">
        대결명
      </label>

      <input
        className="
          w-full
          rounded-xl
          border border-slate-200
          bg-white
          px-4 py-3.5
          text-sm
          outline-none
          placeholder:text-slate-400
          focus:border-[rgb(0,224,198)]
          focus:ring-2
          focus:ring-[rgb(0,224,198)]/20
        "
        placeholder="대결명 예) 한강 5km 여성 개인전"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
